import { Component, Input } from '@angular/core';
import { LoadingPresenter } from './loading.presenter';
import { CommonModule } from '@angular/common';
import { ILoadingComponent, ILoadingPresenter } from './interfaces';
import { IAbstractView } from '@core/interfaces';
import { LoadingDisplayModeEnum, LoadingDisplayModeValue } from './enums/loading-display';

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
	imports: [CommonModule],
	providers: [LoadingPresenter],
	standalone: true,
})
export class LoadingComponent extends IAbstractView<ILoadingPresenter> implements ILoadingComponent {
	@Input() mode: LoadingDisplayModeValue = LoadingDisplayModeEnum.TOAST;

	@Input() text?: string;
	@Input() showSpinner: boolean = true;
	@Input() active?: boolean;

	isLoading$ = this.presenter.isLoading$;
	isdeleting$ = this.presenter.isdeleting$;
	isUpdating$ = this.presenter.isUpdating$;
	isAnyAction$ = this.presenter.isAnyAction$;
	translations = this.presenter.translations;
	loadingClassSignal = this.presenter.loadingClassSignal;

	constructor(presenter: LoadingPresenter) {
		super(presenter);
	}

	get showText(): boolean {
		if (this.text !== undefined) {
			return this.text.trim().length > 0;
		}
		return true;
	}
}
